/**
 * Переиспользуемый редактор AvailabilitySchedule (дни недели + окно времени).
 * Используется AvailabilityEditor (Product/Category) и PriceListsPage
 * (branch-scoped расписание прайс-листа) — одна и та же форма данных
 * ({weekdays?, time_from?, time_to?}), один и тот же набор правил валидации
 * (validateSchedule в AvailabilityEditor.tsx).
 */
import React from 'react';
import { Checkbox, Space, TimePicker, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { WEEKDAYS, AvailabilitySchedule } from './availabilityTypes';

const { Text } = Typography;

function toTimeDayjs(v?: string | null): Dayjs | null {
  if (!v) return null;
  return dayjs(v, 'HH:mm');
}

interface Props {
  value?: AvailabilitySchedule | null;
  onChange?: (value: AvailabilitySchedule | undefined) => void;
  disabled?: boolean;
  note?: React.ReactNode;
}

const ScheduleEditor: React.FC<Props> = ({ value, onChange, disabled, note }) => {
  const sched = value ?? {};

  const patch = (partial: Partial<AvailabilitySchedule>) => {
    const next: AvailabilitySchedule = { ...sched, ...partial };
    const isEmpty = !next.weekdays?.length && !next.time_from && !next.time_to;
    onChange?.(isEmpty ? undefined : next);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {note && (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {note}
        </Text>
      )}
      <Checkbox.Group
        disabled={disabled}
        options={WEEKDAYS}
        value={sched.weekdays ?? []}
        onChange={(v) => patch({ weekdays: (v as number[]).length ? (v as number[]) : undefined })}
      />
      <Space>
        <TimePicker
          format="HH:mm"
          placeholder="С"
          disabled={disabled}
          value={toTimeDayjs(sched.time_from)}
          onChange={(t) => patch({ time_from: t ? t.format('HH:mm') : undefined })}
        />
        <TimePicker
          format="HH:mm"
          placeholder="До"
          disabled={disabled}
          value={toTimeDayjs(sched.time_to)}
          onChange={(t) => patch({ time_to: t ? t.format('HH:mm') : undefined })}
        />
      </Space>
      <Text type="secondary" style={{ fontSize: 12 }}>
        Ночные интервалы (например 22:00–02:00) поддерживаются. Оставьте оба поля пустыми для доступности весь день.
      </Text>
    </Space>
  );
};

export default ScheduleEditor;
